import { IFilter } from "../models/filters/filter";
import { IAgentFilter } from "../models/filters/agentFilter";
import _o2sService from "./_o2sServices";
import { IAgentForm } from "../models/forms/agentForm";
import { IAgentPDTO } from "../models/dtos/agentPDTO";
import { API_CENTRE } from "./config";

export default class AgentServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/agents";

    protected static override getUrlFilter<F extends IAgentFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != undefined) 
        {
            if ( filter.code != undefined)
                url += `&Code=${filter.code}`;
            if ( filter.businessCode != undefined)
                url += `&BusinessCode=${filter.businessCode}`;
            if ( filter.centerId != undefined)
                url += `&CenterId=${filter.centerId}`;
            if ( filter.allAgent != undefined)
                url += `&AllAgent=${filter.allAgent}`;
        }
        return url;
    }
    
    protected static override toDTO(obj:IAgentForm):IAgentPDTO {
        const dto = super.toDTO(obj) as IAgentPDTO;
        
        return dto;
    }
}